import { createHttpLink } from '@apollo/client';

export const httpLink = createHttpLink({
  uri: `${import.meta.env.VITE_GQL_BASE_URL}/v1/graphql/query`,
});
